import type { TUserListCatalogType } from "~/types/catalog";
import { BaseCatalog } from "./base-catalog";
import type { IUserListCatalogPayload } from "~/types/payload";

export class UserListCatalog extends BaseCatalog {

    public type: TUserListCatalogType = 'favorites';

    public override __restore(data: IUserListCatalogPayload): void {
        super.__restore(data);
        this.type = data.type;
    }

    public override __save(): IUserListCatalogPayload {
        const data = super.__save() as IUserListCatalogPayload;
        data.type = this.type;
        return data;
    }
}
